import type { DemoKey } from '../types';

export const nl: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Wiskunde · Statistiek',
  'app.title': 'Statistiek',
  'panel.experiment': 'Scène',
  'panel.params': 'Parameters',

  'exp.survey-explorer.title': 'Enquête-verkenner',
  'exp.survey-explorer.desc': 'Kies een kolom; de demo kiest de juiste samenvatting.',
  'exp.distribution-sculptor.title': 'Verdelingsbeeldhouwer',
  'exp.distribution-sculptor.desc': 'Sleep punten en zie hoe statistieken reageren.',
  'exp.two-variable-lab.title': 'Twee-variabelenlab',
  'exp.two-variable-lab.desc': 'Spreiding, fitten, en de oorzaak-vraag.',
  'exp.sampling-lab.title': 'Steekproeflab',
  'exp.sampling-lab.desc': 'Hoe techniek en grootte het steekproefgemiddelde verschuiven.',
  'exp.probability-diagrams.title': 'Kansdiagrammen',
  'exp.probability-diagrams.desc': 'Venn- en boomweergaven voor samengestelde gebeurtenissen.',

  'type.qualitative-nominal.label': 'Kwalitatief · nominaal',
  'type.qualitative-nominal.def': 'Categorieën zonder volgorde.',
  'type.qualitative-ordinal.label': 'Kwalitatief · ordinaal',
  'type.qualitative-ordinal.def': 'Categorieën met zinvolle volgorde.',
  'type.qualitative-multi.label': 'Kwalitatief · meerwaardig',
  'type.qualitative-multi.def': 'Elke waarneming kan meerdere labels hebben.',
  'type.quantitative-discrete.label': 'Kwantitatief · discreet',
  'type.quantitative-discrete.def': 'Getallen in vaste stappen.',
  'type.quantitative-continuous.label': 'Kwantitatief · continu',
  'type.quantitative-continuous.def': 'Getallen op een continue schaal.',

  'column.name.label': 'Naam leerling',
  'column.height_cm.label': 'Lengte',
  'column.shoe_size_eu.label': 'Schoenmaat (EU)',
  'column.study_hours.label': 'Studie-uren / week',
  'column.test_score.label': 'Toetsresultaat',
  'column.sports_played.label': 'Beoefende sporten',
  'column.eye_color.label': 'Oogkleur',
  'column.commute_min.label': 'Reistijd',
  'column.grade_year.label': 'Leerjaar',
  'column.homework_effort.label': 'Inzet huiswerk',
  'column.ice-cream-sales.label': 'IJsverkoop',
  'column.drownings.label': 'Verdrinkingen',
  'column.month.label': 'Maand',
  'column.storks.label': 'Ooievaars',
  'column.births.label': 'Geboorten',
  'column.country_area_km2.label': 'Oppervlakte land',
  'column.sleep_hours.label': 'Slaapuren',
  'column.reaction_ms.label': 'Reactietijd',

  'dataset.master-survey.label': 'Klasse-enquête',
  'dataset.master-survey.desc': '30 gesimuleerde leerlingen.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'IJsverkoop vs verdrinking',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Beide stijgen en dalen met het seizoen. Verdrinkingen veroorzaken geen ijsverkoop.',
  'dataset.spurious-storks-vs-births.label': 'Ooievaars vs geboorten',
  'dataset.spurious-storks-vs-births.desc':
    'Grotere landen hebben meer ooievaars en meer geboorten. Vogels zijn niet de oorzaak.',
  'dataset.real-sleep-vs-reaction-time.label': 'Slaap vs reactietijd',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Meer slaap, snellere reactie. Een echte negatieve correlatie — met een plausibel mechanisme.',

  'tag.football.label': 'Voetbal',
  'tag.basketball.label': 'Basketbal',
  'tag.volleyball.label': 'Volleybal',
  'tag.swimming.label': 'Zwemmen',
  'tag.none.label': 'Geen',

  'population.gaussian.label': 'Klokvorm',
  'population.right-skewed.label': 'Rechts scheef',
  'population.bimodal.label': 'Bimodaal (gelaagd)',
  'population.uniform.label': 'Uniform',

  'venn.dice-even-or-prime.label': 'Dobbelsteen: even of priem',
  'venn.class-sports-2set.label': 'Sporten (2 verz.)',
  'venn.class-sports-3set.label': 'Sporten (3 verz.)',
  'venn.custom.label': 'Aangepast',

  'tree.draw-without-replacement.label': 'Trekken zonder terugleggen',
  'tree.custom.label': 'Aangepast',
  'tree.coin.heads': 'K',
  'tree.coin.tails': 'M',
  'tree.draw.start': 'Zak: 2 rode, 3 blauwe',
  'tree.draw.red': 'Rood',
  'tree.draw.blue': 'Blauw',
  'tree.custom.start': 'Start',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Histogram',
  'card.cumulative': 'Cumulatieve frequentie',
  'card.box': 'Boxplot',
  'card.summary': '5-getallen-samenvatting',
  'card.bar': 'Staafdiagram',
  'card.mode': 'Modus',
  'card.tag-frequency': 'Labelfrequentie',
  'card.mode-tag': 'Topdominant label',
  'card.empty-no-order': 'N.v.t.',
  'card.empty-multi': 'N.v.t.',
  'card.numberline': 'Getallenlijn',
  'card.scatter': 'Spreiding',
  'card.description': 'Wat gebeurt er',
  'card.population': 'Populatie',
  'card.sampling-distribution': 'Steekproefgemiddelden',
  'card.venn': 'Venn',
  'card.tree': 'Boom',
  'card.probabilities': 'Kansen',

  'param.dataset.label': 'Dataset',
  'param.column.label': 'Kolom',
  'param.bins.label': 'Klassen',
  'param.shape.label': 'Startvorm',
  'param.show-mean.label': 'Toon gemiddelde',
  'param.show-median.label': 'Toon mediaan',
  'param.x-col.label': 'X-kolom',
  'param.y-col.label': 'Y-kolom',
  'param.show-regression.label': 'Regressielijn',
  'param.show-residuals.label': 'Residuen',
  'param.show-confounder.label': 'Toon verstorende variabele',
  'param.population.label': 'Populatie',
  'param.technique.label': 'Techniek',
  'param.sample-size.label': 'Steekproefomvang',
  'param.stratum.label': 'Stratum',
  'param.bias.label': 'Bias',
  'param.mode.label': 'Modus',
  'param.preset.label': 'Voorkeur',
  'param.universe.label': 'Universumgrootte',
  'param.show-prob.label': 'Toon kansen',
  'param.treat-as-numeric.label': 'Numeriek behandelen',

  'stat.count': 'Aantal',
  'stat.mean': 'Gemiddelde',
  'stat.median': 'Mediaan',
  'stat.range': 'Bereik',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'Uitschieters',
  'stat.r': 'Pearson r',
  'stat.r2': 'r²',
  'stat.slope': 'Helling',
  'stat.intercept': 'Snijpunt',
  'stat.n': 'n',
  'stat.population-mean': 'Werkelijk gemiddelde',
  'stat.latest-sample-mean': 'Steekproefgemiddelde',
  'stat.sample-mean-spread': 'SD steekproefgemiddelde',
  'stat.sample-count': 'Genomen steekproeven',
  'outlier.upper': 'Bovenste uitschieters',
  'outlier.lower': 'Onderste uitschieters',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Opnieuw bemonsteren',
  'btn.run-100': '100 steekproeven',
  'btn.stop': 'Stop',
  'btn.clear-history': 'Geschiedenis wissen',

  'explainer.no-order': 'Geen volgorde → geen cumulatief, geen boxplot.',
  'explainer.multi-no-iqr': 'Meerwaardig → kwartielen / IQR niet gedefinieerd.',
  'message.no-data': 'Geen data.',
  'message.needs-quartiles': '≥4 punten nodig voor kwartielen.',
  'message.x-zero-variance': 'X heeft variantie 0 — geen lijn aan te passen.',
  'message.n-too-small': 'n te klein.',
  'message.stratum-clamp': 'Stratum had minder rijen dan gevraagd — alle gebruikt.',
  'message.siblings-sum-to-one': 'Kinderen moeten optellen tot 1.',
};
